import DocumentPortalView from '../example/views/DocumentPortalView.vue';

const clientPortalRoutes = [
  {
    path: '/portal/:firmSlug/:advisorSlug/:entityExternalId',
    name: 'client-portal',
    component: DocumentPortalView,
    props: route => ({
      firmSlug: route.params.firmSlug,
      advisorSlug: route.params.advisorSlug,
      entityExternalId: route.params.entityExternalId,
      portalType: 'client',
      redirect: route.query.redirect
    }),
    meta: { 
      requiresAuth: false,
      showNav: false,
      showFooter: false
    }
  },
  {
    path: '/visitor/invitation/:token',
    name: 'public-invitation-preview',
    component: DocumentPortalView,
    props: route => ({
      token: route.params.token,
      previewMode: true
    }),
    meta: { 
      requiresAuth: false,
      showNav: false,
      showFooter: false
    }
  },
  {
    path: '/client/verify',
    name: 'client-verify',
    component: DocumentPortalView,
    props: route => ({ 
      token: route.query.token,
      entityExternalId: route.query.entityExternalId, 
      advisorSlug: route.query.advisor
    }),
    meta: { 
      requiresAuth: false,
      showNav: false,
      showFooter: false,
      clientOnly: true
    }
  },
  {
    path: '/client/dashboard',
    name: 'client-dashboard',
    component: DocumentPortalView,
    props: route => ({
      entityExternalId: route.query.entity  || localStorage.getItem('preview_entity') || '',
      advisorSlug:      route.query.advisor  || localStorage.getItem('preview_advisor')  || '',
    }),
    meta: { 
      requiresAuth: false,
      clientOnly: true
    }
  },
  {
    path: '/advisor/client-portal/dashboard/:firmSlug/:advisorSlug/:entityExternalId',
    name: 'advisor-client-portal-dashboard',
    component: DocumentPortalView,
    props: route => ({
      firmSlug: route.params.firmSlug,
      advisorSlug: route.params.advisorSlug,
      entityExternalId: route.params.entityExternalId,
      advisorView: true,
      previewMode: false,
      // redirect: route.query.redirect
    }),
    meta: { 
      requiresAuth: false,
      advisorOnly: true,
      showNav: false,
      showFooter: false
    }
  },
];

export default clientPortalRoutes; 
